import { Affaire, ExpertiseData } from '../types/search.types'
import { formatAddress, formatPrice, getStatusColor, getCategory, getCompletionPercentage } from './formatters'

export const transformAffaireToExpertiseData = (affair: Affaire): ExpertiseData => {
  return {
    id: affair.id_unique,
    affaire_id: affair.id_unique,
    date: affair.date_sortie || '',
    type: affair.type_mission || 'Type non spécifié',
    category: getCategory(affair.type_mission),
    address: formatAddress(affair.address),
    status: affair.statut_affaire || 'En attente',
    statusColor: getStatusColor(affair.statut_affaire),
    price: formatPrice(affair.montant_tvac_affaire),
    expert: affair.expert || 'Expert non assigné',
    estimatedDuration: '3-5 jours',
    priority: 'normal',
    completionPercentage: getCompletionPercentage(affair.statut_affaire),
    tags: ['Données FM'],
    facturation: affair.facturation
  }
}

export const getFilterPills = () => [
  { key: 'all', label: 'Tous' },
  { key: 'expertise', label: 'Expertises' },
  { key: 'peb', label: 'PEB' },
  { key: 'rentalPermit', label: 'Permis de location' }
]

export const getSortOptions = () => [
  { value: 'date', label: 'Date' },
  { value: 'type', label: 'Type' },
  { value: 'status', label: 'Statut' }
]